import { digObject } from '@domain-group/javascript-utils'

import useCurrentUser from '@hooks/useCurrentUser'

import AgencyMarketing, {
  configOptions as agencyMarketingConfigOptions,
  icon as AgencyMarketingIcon,
} from '@components/CustomizableDashboardModules/AgencyMarketing'

import Campaigns, {
  configOptions as campaignsConfigOptions,
  icon as CampaignIcon,
} from '@components/CustomizableDashboardModules/Campaigns'

import Deadlines, {
  icon as DeadlineIcon,
} from '@components/CustomizableDashboardModules/Deadlines'

import Notifications, {
  configOptions as notificationConfigOptions,
  icon as notificationsIcon,
} from '@components/CustomizableDashboardModules/Notifications'

import Orders, {
  configOptions as orderConfigOptions,
  icon as ordersIcon,
} from '@components/CustomizableDashboardModules/Orders'

import Quotes, {
  configOptions as quoteConfigOptions,
  icon as quotesIcon,
} from '@components/CustomizableDashboardModules/CampaignQuotes'

import ReviewedArtworks, {
  configOptions as reviewedArtworksConfigOptions,
  icon as reviewedArtworksIcon,
} from '@components/CustomizableDashboardModules/ReviewedArtworks'

export const generateAvailableModules = (currentUserPayload: ReturnType<typeof useCurrentUser>) => {
  const { currentUser, isAgent } = currentUserPayload

  const customisableDashboardModules = {
    Campaigns: {
      component: Campaigns,
      // @ts-expect-error TS2322
      configOptions: campaignsConfigOptions({ currentUser, isAgent }),
      icon: CampaignIcon,
      id: 'Campaigns',
      isSelectable: true,
      title: 'Campaigns',
    },
    Deadlines: {
      component: Deadlines,
      icon: DeadlineIcon,
      id: 'Deadlines',
      isSelectable: true,
      title: 'Deadlines',
    },
    AgencyMarketing: {
      component: AgencyMarketing,
      configOptions: agencyMarketingConfigOptions(),
      icon: AgencyMarketingIcon,
      id: 'AgencyMarketing',
      isSelectable: true,
      title: 'Marketing & Stationery',
    },
    Notifications: {
      component: Notifications,
      configOptions: notificationConfigOptions(),
      icon: notificationsIcon,
      id: 'Notifications',
      isSelectable: true,
      title: 'Notifications',
    },
    Orders: {
      component: Orders,
      // @ts-expect-error TS2322
      configOptions: orderConfigOptions({ currentUser, isAgent }),
      id: 'Orders',
      icon: ordersIcon,
      isSelectable: true,
      title: 'Orders',
    },
    Quotes: {
      component: Quotes,
      // @ts-expect-error TS2322
      configOptions: quoteConfigOptions({ currentUser, isAgent }),
      icon: quotesIcon,
      id: 'Quotes',
      mergeConfig: {
        requestOptions: {
          include_campaign_quote_campaign: true,
        },
      },
      isSelectable: true,
      title: 'Quotes',
    },
    ReviewedArtworks: {
      component: ReviewedArtworks,
      // @ts-expect-error TS2322
      configOptions: reviewedArtworksConfigOptions({ currentUser, isAgent }),
      icon: reviewedArtworksIcon,
      id: 'ReviewedArtworks',
      isSelectable: true,
      title: 'Reviewed Artworks',
    },
  }

  const filteredModules = {}

  Object.keys(customisableDashboardModules).forEach((module) => {
    // @ts-expect-error TS7053
    const targetModule = customisableDashboardModules[module]

    if (targetModule.isSelectable){
      // @ts-expect-error TS7053
      filteredModules[module] = targetModule
    }
  })

  return filteredModules as Partial<typeof customisableDashboardModules>
}

type DefaultModule = {
  key: string,
  moduleId: string,
  isAllowed?: boolean,
}

export const dashboardDefaultLayout = () => {
  const defaultLayout = {
    columns: {
      main: {
        id: 'main',
        modules: [
          {
            key: 'Campaigns-1',
            moduleId: 'Campaigns',
            isAllowed: true,
          },
        ],
      },
      sidebar: {
        id: 'sidebar',
        modules: [
          { key: 'Deadlines-1', moduleId: 'Deadlines' },
          { key: 'ReviewedArtworks-1', moduleId: 'ReviewedArtworks' },
          { key: 'Notifications-1', moduleId: 'Notifications' },
        ],
      },
    },
    custom: false,
    options: {
      'Campaigns-1': {
        customization: { display_mode: 'tiles', title: 'Campaigns' },
        queryParams: {
          campaign_status: '',
          limit: 50,
          priority_campaign_user_id: '',
        },
      },
      'ReviewedArtworks-1': {
        customization: {},
        queryParams: {
          priority_reviewed_artworks_by_user_id: 'all',
        },
      },
    },
  }

  const filteredDefaultLayout = JSON.parse(JSON.stringify(defaultLayout))

  const defaultModulesMain: DefaultModule[] = digObject(defaultLayout, 'columns.main.modules', {})
  defaultModulesMain.forEach((module, index) => {
    if (!module.isAllowed){
      filteredDefaultLayout.columns.main.modules.splice(index, 1)
    }
  })

  const defaultModulesSideBar: DefaultModule[] = digObject(filteredDefaultLayout, 'columns.sidebar.modules', {})
  defaultModulesSideBar.forEach((module, index) => {
    if (!module.isAllowed){
      filteredDefaultLayout.columns.sidebar.modules.splice(index, 1)
    }
  })
  return filteredDefaultLayout
}
